import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../store/auth";

export function Onboarding() {
  const { user, refresh } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (user && !user.onboarding_completed) setOpen(true);
  }, [user]);
  if (!open || !user) return null;
  return (
    <div className="modal-bg" role="dialog" aria-labelledby="ob-title">
      <div className="modal">
        <h2 id="ob-title">How Softwave Markets works</h2>
        <div className="onboard-steps">
          <div>1. Find a question.</div>
          <div>2. Choose YES or NO.</div>
          <div>3. Buy contracts from other traders.</div>
          <div>4. Trade out, or wait for resolution.</div>
          <div>5. Winning contracts settle at $1.00 from reserved collateral.</div>
        </div>
        <p>Softwave is the marketplace — not the other side of your trade.</p>
        <button className="btn btn-primary" onClick={async () => {
          await api("/auth/onboarding-complete", { method: "POST" });
          await refresh();
          setOpen(false);
        }}>Got it</button>
      </div>
    </div>
  );
}
